import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import { logbookListHeader } from "@/constants/defaultHeader";
export default {
	state: {

		// УДАЛИТЬ когда перенесу, используется в бригих разделах ссілка на открітие кастомера из таблиці
		isInformationPopup: null,
		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці

		listLogbooks: null,
		orderLogbooks: null,
		sortLogbooks: null,
		limitLogbooks: null,
		totalLogbooks: null,
		createLogbooksReports: null,
		filtersLogbooks: null,
		totalsLogbooks: null,
		preloaderFiltersLogbooks: true,
		preloaderTotalsLogbooks: true,
		driverActionsLogbooks: [],
		eldList: null,
		safetyCreateCustomers: [],
		safetyCreateRequest: [],
	},
	mutations: {
		logbooksDeleteAction(state, payload) {
			state.driverActionsLogbooks.list.map(action => action.id === payload.id && (action.status = 0));
		},
		updateLogbooksDriverActions(state, payload) {
			payload && (state.driverActionsLogbooks = payload);
		},
		updateLogbooksList(state, payload) {
			const { customers, order, sort, limit, total } = payload;
			state.listLogbooks = customers;
			state.orderLogbooks = order;
			state.sortLogbooks = sort;
			state.limitLogbooks = limit;
			state.totalLogbooks = total;
		},
		updatePreloaderFilters(state, payload) {
			state.preloaderFiltersLogbooks = payload;
		},
		updatePreloaderTotalsLogbooks(state, payload) {
			state.preloaderTotalsLogbooks = payload;
		},
		updateCreateLogbooksReports(state, payload) {
			state.createLogbooksReports = Object.values(payload.customers);
		},
		updateLogbooksFilters(state, payload) {
			state.filtersLogbooks = payload.filter;
		},
		updateLogbooksTotal(state, payload) {
			state.totalsLogbooks = payload;
		},

		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці
		updateInformation(state, payload) {
			state.isInformationPopup = payload;
		},
		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці

		updateEldList(state, { rows = [] }) {
			state.eldList = rows;
		},
		updateSafetyCreateInfo(state, { customers, request }) {
			state.safetyCreateCustomers = customers;
			state.safetyCreateRequest = request;
		}
	},
	actions: {
		async addLogbooksDriverAction({ commit, dispatch }, payload) {
			const { note, id, dateTime } = payload;
			const driver_date = payload.date;

			try {
				const { data } = await httpClient.post(`/safety/${ id }/${ driver_date }`, { note, dateTime });

				if (data && data.status) {
					commit('updateLogbooksDriverActions', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async editLogbooksDriverAction({ commit, dispatch }, payload) {
			const { note, driver_id, id, dateTime } = payload;
			const driver_date = payload.date;

			try {
				const { data } = await httpClient.post(`/safety/${ driver_id }/${ driver_date }`, { note, dateTime, id });

				if (data && data.status) {
					commit('updateLogbooksDriverActions', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onLogbooksDriverActions({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			const { id, date } = payload;

			try {
				const { data } = await httpClient.get(`/safety/${ id }/${ date }`);

				if (data && data.status) {
					commit('updateLogbooksDriverActions', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async deleteLogbooksDriverAction({ commit, dispatch }, payload) {
			const { driver_id } = payload;
			const driver_date = payload.date;

			try {
				const { data } = await httpClient.post(`/safety/${ driver_id }/${ driver_date }`, payload);

				if (data && data.status) {
					commit('updateLogbooksDriverActions', data);
					dispatch("actionPreloader", false);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async getLogbooksList({ commit, dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				const { data } = await httpClient.post('/safety/list', value);

				if (data && data.status) {
					commit('updateLogbooksList', data);
					commit('updateSettings', { settings: data.settings, key: requestKeys.SAFETY, defaultHeader: logbookListHeader });
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async getCreateLogbooksReports({ commit, dispatch }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/reports/safety/create', value);
				if (data && data.status) {
					commit('updateCreateLogbooksReports', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async setCreateLogbooksReports({ dispatch }, value) {
			try {
				dispatch("actionPreloader", true);
				await httpClient.post('/reports/safety', value);
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},

		async getFiltersLogbooks({ commit, dispatch }, value) {
			dispatch("actionPreloader", true);
			commit('updatePreloaderFilters', true);
			commit('updatePreloaderTotalsLogbooks', true);
			try {
				const { data } = await httpClient.post('/safety/filters', value);

				if (data && data.status) {
					commit('updateLogbooksFilters', data);
					commit('updatePreloaderFilters', false);
				}

				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async getTotalLogbooks({ commit }, value) {
			try {
				const { data } = await httpClient.post(`/safety/statistics`, value);

				if (data) {
					commit('updateLogbooksTotal', data);
					commit('updatePreloaderTotalsLogbooks', false);
				}
			} catch (e) {
				console.error(e);
			}
		},

		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці

		onInformation({ commit }, value) {
			commit('updateInformation', value);
		},

		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці

		async getEldList({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`safety/access/${ id }`);
				if (data) {
					commit('updateEldList', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		onClearEld({ commit }) {
			commit('updateEldList', { rows: null });
		},

		async getSafetyCreateCustomers({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/safety/create`);
				commit('updateSafetyCreateInfo', data);
				dispatch("actionPreloader", false);
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},

		async getSafetyCreateAction({ dispatch }, value) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/safety/action`, value);
				dispatch("actionPreloader", false);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "😊 Action was created successfully." });
				} else {
					dispatch('setAlert', { type: "error", message: "😥 Failed to send. Something went wrong." });
				}
			} catch (e) {
				dispatch("actionPreloader", false);
				console.error(e);
			}
		},
	},
	getters: {
		listLogbooks: s => s.listLogbooks,
		orderLogbooks: s => s.orderLogbooks,
		sortLogbooks: s => s.sortLogbooks,
		limitLogbooks: s => s.limitLogbooks,
		totalLogbooks: s => s.totalLogbooks,
		filtersLogbooks: s => s.filtersLogbooks,
		createLogbooksReports: s => s.createLogbooksReports,
		totalsLogbooks: s => s.totalsLogbooks,
		preloaderFiltersLogbooks: s => s.preloaderFiltersLogbooks,
		preloaderTotalsLogbooks: s => s.preloaderTotalsLogbooks,
		driverActionsLogbooks: s => s.driverActionsLogbooks,
		eldList: s => s.eldList,
		safetyCreateCustomers: s => s.safetyCreateCustomers,
		safetyCreateRequest: s => s.safetyCreateRequest,

		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці
		isLogbookLink: s => s.isLogbookLink,
		isInformationPopup: s => s.isInformationPopup,
		// УДАЛИТЬ когда перенесу, ссілка на открітие кастомера из таблиці
	},

};

